module.exports = __webpack_public_path__ + "img/b5_lanyuezhiyi.7dfe8ec3.jpg";